import { render, staticRenderFns } from "./PreliminaryReport.vue?vue&type=template&id=9f652c44&"
import script from "./PreliminaryReport.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryReport.vue?vue&type=script&lang=ts&"
import style0 from "./PreliminaryReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports